var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"agree-header"},[_vm._v("\n    暄桐教室课程学习协议总则\n    "),_c('img',{staticClass:"reel",attrs:{"src":_vm.$images.login_popup_agreement}})]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.formatFace(_vm.agreement.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }